import React from "react";

type Props = {
    type: string;
    placeholder?: string;
    className?: string;
    onBlur?: any;
    onChange?: any;
    value?: string;
};

export default function Input(props: Props)
{
    const className = props.className === undefined ? "" : props.className;
    const placeholder = props.placeholder === undefined ? "" : props.placeholder;

    return (
        <input value={props.value} type={props.type} className={className} placeholder={placeholder} onBlur={props.onBlur} onChange={props.onChange}/>
    );
}